var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2063 3.5168C16.3069 4.89308 18.6573 6.70079 19.8724 7.74551C20.4864 8.27351 20.8288 9.03341 20.8712 9.84213C20.9295 10.9527 21 12.6905 21 14.5912C21 16.0533 20.9583 17.4653 20.9125 18.5739C20.8594 19.8601 19.8367 20.8745 18.5502 20.9185C17.0672 20.9691 14.8667 21.0197 12 21.0197C9.13337 21.0197 6.93287 20.9691 5.44986 20.9185C4.16334 20.8745 3.14067 19.8601 3.08755 18.5739C3.04176 17.4653 3 16.0533 3 14.5912C3 12.6905 3.07058 10.9527 3.12882 9.84209C3.17124 9.03337 3.51361 8.27351 4.12766 7.74556C5.34271 6.70083 7.69311 4.89309 10.7937 3.5168C11.5614 3.17604 12.4387 3.17604 13.2063 3.5168Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57031 18.02H15.4275",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtros);
export default __webpack_public_path__ + "static/media/Otros.538bbe5b40059ce5647ddfd230cd7a74.svg";
export { ForwardRef as ReactComponent };